import { Box, Stack, Typography } from '@mui/material';
import { InputMethod, Question as Q } from '../../graphql/generated/graphql';
import { FC } from 'react';
import { NumberInput } from '../forms/number-input.tsx';
import { TextInput } from '../forms/text-input.tsx';
import { AutoCompleteInput } from '../forms/auto-complete-input.tsx';
import { PositiveMoodInput } from '../forms/positive-mood-input.tsx';
import { NegativeMoodInput } from '../forms/negative-mood-input.tsx';
import { SliderInput } from '../forms/slider-input.tsx';
import { RadioGroupInput } from '../forms/radio-group.tsx';

interface QuestionProps {
  question: Partial<Q>;
  DAY?: string;
}

export const Question: FC<QuestionProps> = ({ question, DAY }) => {
  return (
    <Stack spacing={2}>
      <Typography variant="h6">{question.title?.replace('[DAY]', DAY || '')}</Typography>
      {question.description && <Typography variant="subtitle1">{question.description}</Typography>}
      {question.inputMethod === InputMethod.Number && <NumberInput required name={question._id as string} />}
      {question.inputMethod === InputMethod.Text && <TextInput required name={question._id as string} />}
      {question.inputMethod === InputMethod.DropDown && (
        <AutoCompleteInput name={question._id as string} options={question.dropdownOptions?.map(({ option }) => ({ id: option, label: option })) || []} />
      )}
      {question.inputMethod === InputMethod.Radio && (
        <RadioGroupInput label="" name={question._id as string} options={question.dropdownOptions?.map<string>(({ option }) => option) || []} />
      )}
      {question.inputMethod === InputMethod.PositiveMood && <PositiveMoodInput name={question._id as string} label={''} />}
      {question.inputMethod === InputMethod.NegativeMood && <NegativeMoodInput name={question._id as string} label={''} />}
      {question.inputMethod === InputMethod.Slider && (
        <Box px={4}>
          <SliderInput
            sx={{ mt: 4 }}
            valueLabelDisplay="auto"
            name={question._id as string}
            label={''}
            min={Number(question.minValue)}
            max={Number(question.maxValue)}
            marks={[
              { value: Number(question.minValue), label: question.minLabel },
              { value: Number(question.maxValue), label: question.maxLabel }
            ]}
          />
        </Box>
      )}
    </Stack>
  );
};
